// header buttons only for defautl theme
import headerButtonsMain from "../js/widgets/headerButtonsMain.js";

// header buttons for subpages
import headerButtonsBHSS from "../js/widgets/headerButtonsBHSS.js";
import headerButtonsCSFFoundation from "../js/widgets/headerButtonsCSFFoundation.js";
import headerButtonsCSF from "../js/widgets/headerButtonsCSF.js";
import headerButtonsFairgrounds from "../js/widgets/headerButtonsFairgrounds.js";

// blurry images for subpages
import bhssBlurryImage from "../js/widgets/bhssBlurryImage.js";
import cfsFoundationBlurryImage from "../js/widgets/cfsFoundationBlurryImage.js";
import cfsBlurryImage from "../js/widgets/cfsBlurryImage.js";
import fairgroundsBlurryImage from "../js/widgets/fairgroundsBlurryImage.js";

let subpagesClasses = [
  "BHSS-subpage",
  "fairgrounds-subpage",
  "CSF-subpage",
  "CSF_Foundation-subpage",
];

let subpagesClassesHomepage = [
  "BHSS-homepage",
  "fairgrounds-homepage",
  "CSF-homepage",
  "CSF_Foundation-homepage",
];

$(document).ready(function () {
  if (!validateClass(subpagesClasses)) {
    headerButtonsMain();
  }

  // =============================
  // Script for custom slideshow on subpages
  function validateClass(valuesArray) {
    return Array.from(document.body.classList).some((className) =>
      valuesArray.includes(className)
    );
  }

  if (validateClass(subpagesClassesHomepage)) {
    $('<div id="heroBanner"></div>').prependTo(".wrapper");
    $(".dynamicPageContainer .sectionHeading").each(function () {
      const text = $(this).text();
      if (text === "{custom-slider}") {
        $(this).parent().parent().addClass("custom-slider");
        $(this).remove();

        $(".custom-slider .rowIndex-1 .PageTitleModule ").addClass(
          "custom-title-subpage"
        );
        $(".custom-slider .rowIndex-2").addClass("custom-slider-container");
        $(".custom-slider-container .columnIndex-1").addClass(
          "custom-slider-subpage"
        );
        $(".content").addClass("custom-slider-active");
      }
    });
    setTimeout(() => {
      $("#heroBanner").css("opacity", 1);
      $(".content").css("opacity", 1);
    }, 800);
  } else {
    setTimeout(() => {
      $(".content").css("opacity", 1);
    }, 800);
  }

  if (validateClass(subpagesClassesHomepage)) {
    $(".dynamicPageContainer .sectionHeading").each(function () {
      const text = $(this).text();
      const eventCalendar = $("#multiScheduleFeature");
      if (text === "{event-left}") {
        $(this).parent().addClass("calendar-subpage");
        $(this).parent().find(".columnIndex-1").prepend(eventCalendar);
        $(this).remove();
      } else if (text === "{event-right}") {
        $(this).parent().addClass("calendar-subpage");
        $(this).parent().find(".columnIndex-2").prepend(eventCalendar);
        $(this).remove();
      }
    });
  }

  //   function to validate class
  function validClassHomepage(classCheck) {
    return $(body).hasClass(classCheck);
  }
  switch (true) {
    case validClassHomepage("BHSS-homepage"):
      bhssBlurryImage();
      break;

    case validClassHomepage("CSF-homepage"):
      cfsBlurryImage();
      break;

    case validClassHomepage("CSF_Foundation-homepage"):
      cfsFoundationBlurryImage();
      break;

    case validClassHomepage("fairgrounds-homepage"):
      fairgroundsBlurryImage();
      break;
  }

  function validClassSubpage(classCheck) {
    return $(body).hasClass(classCheck);
  }
  switch (true) {
    case validClassSubpage("BHSS-subpage"):
      headerButtonsBHSS();
      break;

    case validClassSubpage("CSF-subpage"):
      headerButtonsCSF();
      break;

    case validClassSubpage("CSF_Foundation-subpage"):
      headerButtonsCSFFoundation();
      break;

    case validClassSubpage("fairgrounds-subpage"):
      headerButtonsFairgrounds();
      break;
  }

  // Removing subpages sponsors if no sponsors are loaded
  $(window).load(function () {
    setTimeout(() => {
      $(".subpage-sponsors .sp-sponsor").each(function name() {
        if ($(this).children().length <= 0) {
          $(this).parent().remove();
        }
      });
    }, 800);
  });

  setTimeout(() => {
    $(".logo-container").css("opacity", "1");
  }, 400);
});
